import { GetFileExtension, getJwt, imageFormats } from '@app/helpers';
import { trackPromise } from 'react-promise-tracker';
import Axios from 'axios';
import api from './api';

export interface DadosGerais {
  medicaoId: string;
  id: string;
  numeroContrato: number;
  numeroBm: number;
  administrador: string;
  periodoInicio: Date;
  periodoFim: Date;
  statusNome: string;
  statusCodigo: number;
  conformidade: number;
  dataConclusao: Date;
  nivelConformidade: string;
  modoGeracao: string;
  justificativaNaoAplicavel: string;
  usuarioGestorId: string;
}

export interface ControleQaqc {
  id: string;
  medicaoId: string;
  contratoId: string;
  periodoFim: Date;
  periodoInicio: Date;
  numeroBm: number;
  numeroContrato: number;
  fornecedor: string;
  administrador: string;
  statusNome: string;
  statusCodigo: number;
  conformidade: number;
  dataConclusao: Date;
  nivelConformidade: string;
  justificativaNaoAplicavel: string;
  identificadorPQ?: string;
  isMultiplosGestores?: boolean;
  isResponsavel?: boolean;
  escopo?: string;
}

export interface LinhaQaqc {
  id: string;
  atividade: string;
  acao: string;
  pesoPergunta: number;
  resultado: string;
  justificativa: boolean;
  contemJustificativa: boolean;
  resumoNaoConformidade: string;
  arquivos: any[];
}

export interface HistoricoControleQaqc {
  id: string;
  medicaoId: string;
  usuarioResponsavel?: string;
  statusAnterior?: string;
  novoStatus?: string;
  descricao?: string;
  dataHoraFormatada: string;
}

export const optionsNivelConformidade = [
  {
    text: 'Atende',
    value: 'Atende',
  },
  {
    text: 'Atende Parcialmente',
    value: 'Atende Parcialmente',
  },
  {
    text: 'Não Atende',
    value: 'Não Atende',
  },
  {
    text: '',
    value: '',
  }
];

export const optionsConformidade = [
  {
    text: 'Sim',
    value: 1,
  },
  {
    text: 'Não',
    value: 0,
  },
];

export const getAllControleQaqc = () => api.get<ControleQaqc[]>(`controleQaqc`);
export const getHistorico = (id: string) => api.get<HistoricoControleQaqc[]>(`controleQaqc/GetHistorico/${id}`);
export const getDadosGerais = (id: string) => api.get<DadosGerais>(`controleQaqc/dadosGerais/${id}`);
export const getLinhasQaqc = (id: string) => api.get<LinhaQaqc[]>(`controleQaqc/GetLinhas/${id}`);
export const updateLinhaQaqc = (values: any) => api.post<any>(`controleQaqc/UpdateLinha`, values);
export const updateNivelConformidade = (values: any) => api.post<any>(`controleQaqc/updateNivelConformidade`, values);
export const updateConformidade = (values: any) => api.post<any>(`controleQaqc/updateConformidade`, values);
export const solicitarJustificativa = (id: string) => api.post<any>(`controleQaqc/solicitarJustificativa`, { id });
export const enviarJustificativa = (id: string) => api.post<any>(`controleQaqc/enviarJustificativa`, { id });
export const concluirQaqc = (id: string) => api.post<any>(`controleQaqc/concluirQaqc`, { id });
export const uploadLinhaFile = (form: any) => api.post<any>(`controleQaqc/UploadLinhaFile`, form);
export const deleteLinhaFile = (id: string) => api.delete(`controleQaqc/DeleteLinhaFile/${id}`);
export const getJustificativas = (id: string) => api.get(`controleQaqc/GetJustificativas/${id}`);
export const salvarJustificativa = (form: any) => api.put(`controleQaqc/PutJustificativas`, form);
export const salvarJustificativaNaoAplicavel = (form: any) => api.put(`controleQaqc/PutJustificativasNaoAplicavel`, form);
export const usuarioLogadoAdmContratoControleQaqc = (id: string) =>
  api.get<boolean>(`controleQaqc/usuarioLogadoAdmContratoControleQaqc/${id}`);
export const usuarioLogadoGestorContratoControleQaqc = (id: string) =>
  api.get<boolean>(`controleQaqc/usuarioLogadoGestorContratoControleQaqc/${id}`);

export const viewLinhaFile = async (id, nome) => {
  var url = window.location.origin + `/api/controleQaqc/DownloadLinhaFile/${id}`;
  await Axios.get(url, {
    headers: {
      Authorization: `Bearer ${getJwt()}`,
    },
    responseType: 'blob',
  }).then(response => {
    let file = undefined;
    let fileUrl = undefined;
    const fileExtension = GetFileExtension(nome);
    if (fileExtension === 'pdf') {
      file = new Blob([response.data], { type: 'application/pdf' });
      fileUrl = URL.createObjectURL(file);
    } else if (imageFormats.includes(fileExtension)) {
      file = new Blob([response.data], { type: 'image/' + fileExtension });
      fileUrl = URL.createObjectURL(file);
    }
    if (fileUrl !== undefined) var resp = window.open(fileUrl);
  });
};

export const downloadLinhaFile = (id: string, nome: string) => {
  let urlBase = window.location.origin;
  trackPromise(
    Axios.get(urlBase + `/api/controleQaqc/DownloadLinhaFile/${id}`, {
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${getJwt()}`,
      },
    }).then(resp => {
      const url = window.URL.createObjectURL(new Blob([resp.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', nome);
      link.setAttribute('id', 'downloadLinhaFile');
      document.body.appendChild(link);
      link.click();
      document.getElementById('downloadLinhaFile').outerHTML = '';
    }),
  );
};

export const CreateControleQaqc = (values: any) => api.post<any>(`controleQaqc/CreateControleQaqc`, values);